import Vue from 'vue';
import { router } from '@src/routes';

export function beforeRouteEnter(to, from, next) {
    if (window.content) {
        next((vm) => {
            vm.template = window.content;
            window.content = undefined;
        });
    } else {
        const path = to.path.replace(router.history.base, '');
        Vue.http.get(`templates${path}`, { params: to.query }).then(
            (data) => {
                next((vm) => {
                    vm.template = data.data;
                });
            },
            (data) => {
                if (data.status === 403) {
                    next({name: 'E403'});
                } else {
                    next({name: 'E404'});
                }
            }
        );
    }
}

export function beforeRouteUpdate(to, from, next) {
    const path = to.path.replace(router.history.base, '');
    Vue.http.get(`templates${path}`, { params: to.query }).then(
        (data) => {
            next();
            this.template = data.data;
        },
        (data) => {
            if (data.status === 403) {
                next({name: 'E403'});
            } else {
                next({name: 'E404'});
            }
        }
    );
}

export default {beforeRouteUpdate, beforeRouteEnter}




// WEBPACK FOOTER //
// ./src/assets/js/routerPageHook.js